// extracted by mini-css-extract-plugin
export default {"wrapper":"AccessibilityElement__wrapper--3n9","inline":"AccessibilityElement__inline--27P","focused":"AccessibilityElement__focused--3LM"};